module.exports = __webpack_public_path__ + "img/raonfit-logo.08e7b932.png";